import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Dropdown from 'react-bootstrap/Dropdown'
import { SendMessageSVG } from 'src/components/Icons/Basic'

export const TrusteroIntelligencePageContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100vw - 60px);
  flex: 1;
  background-color: ${palette.neutral.white};
`

export const PanelIcon = styled.div`
  display: flex;
  cursor: pointer;
  svg {
    min-width: 20px;
    min-height: 20px;
    path {
      fill: ${palette.neutral[600]};
    }
  }
`

export type ChatCollapsiblePanelDirection = 'east' | 'west'

export const ChatCollapsiblePanelContainer = styled.div<{
  $collapseDirection: ChatCollapsiblePanelDirection
  $isCollapsed: boolean
  $hasShortTitle: boolean
  $noBorder: boolean
}>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: calc(100vh - 60px); // for the header
  width: ${({ $isCollapsed, $hasShortTitle, $collapseDirection }) =>
    $isCollapsed
      ? $hasShortTitle
        ? $collapseDirection === 'east'
          ? '125px'
          : '100px'
        : '50px'
      : '300px'};
  transition: width 0.3s ease-in-out;
  padding: 16px;
  ${({ $collapseDirection, $isCollapsed, $noBorder }) =>
    $collapseDirection === 'west' &&
    !$isCollapsed &&
    !$noBorder &&
    `border-right: 1px solid ${palette.neutral[100]};`}
  ${({ $collapseDirection, $isCollapsed, $noBorder }) =>
    $collapseDirection === 'east' &&
    !$isCollapsed &&
    !$noBorder &&
    `border-left: 1px solid ${palette.neutral[100]};`}
`

export const ChatCollapsiblePanelContent = styled.div<{
  $isCollapsed: boolean
}>`
  display: ${({ $isCollapsed }) => ($isCollapsed ? 'none' : 'flex')};
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
  height: 100%;
`

export const ChatCollapsiblePanelFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
`

export const ChatCollapsiblePanelHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ChatCollapsiblePanelHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const ChatCollapsiblePanelTitleText = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${palette.blue[700]};
`

export const ChatCollapsiblePanelTitle = styled(ChatCollapsiblePanelTitleText)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const ChatCollapsiblePanelDescription = styled.p`
  font-weight: 400;
  font-style: italic;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
  color: ${palette.neutral[900]};
`

export const CollapsedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const ChatPromptInputContainer = styled.div<{
  $isSuggestionsOpen?: boolean
  $isAgentChat?: boolean
  $isDragActive?: boolean
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${palette.neutral[100]};
  border-radius: ${({ $isSuggestionsOpen }) =>
    $isSuggestionsOpen ? '6px 6px 0 0' : '6px'};
  padding: 8px 8px 8px 10px;
  gap: 12px;
  position: relative;
  background-color: ${palette.neutral.white};
  ${({ $isAgentChat }) =>
    $isAgentChat &&
    css`
      min-height: 72px;
      border-radius: 65px;
      justify-content: center;
      padding: 20px;
      max-width: 880px;
      flex-shrink: 0;
    `}
  ${({ $isDragActive }) =>
    $isDragActive &&
    css`
      border: 1px dashed ${palette.blue[500]};
      background-color: ${palette.blue[30]};
    `}
`

export const ChatPromptInputRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`

export const PromptSendButton = styled(FontAwesomeIcon)`
  color: ${palette.neutral[600]};
  width: 14px;
  height: 14px;
  line-height: 21px;
  cursor: pointer;
  flex-shrink: 0;
`

export const AgentPromptSendButton = styled(SendMessageSVG)`
  width: 24px;
  height: 24px;
  line-height: 21px;
  cursor: pointer;
  flex-shrink: 0;
`

export const SuggestedPromptsDropdownMenu = styled(Dropdown.Menu)`
  border-radius: 16px;
`

export const SuggestedPromptsDropdownItem = styled(Dropdown.Item)`
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  white-space: pre-wrap;
  min-width: 500px;
`
